import { validateEmail } from "../Login/Validation";

export interface configureDataType {
  email: string;
  phoneNumber: string;
  price: string;
  validity: string;
  percentage: string;
  renewalGracePeriod: string;
}

export const validateConfigureData = (
  data: configureDataType,
  setConfigureError: React.Dispatch<React.SetStateAction<configureDataType>>
) => {
  let isError = false;
  let numSpacesRegex = /^\+\d+/;
  let isContactValid = data.phoneNumber
    ? numSpacesRegex.test(data.phoneNumber)
    : true;
  if (data.email === "") {
    setConfigureError((prevState: any) => ({
      ...prevState,
      email: "Please enter email",
    }));
    isError = true;
  } else if (!validateEmail(data.email)) {
    setConfigureError((prevState: any) => ({
      ...prevState,
      email: "Please enter valid email",
    }));
    isError = true;
  }
  if (data.phoneNumber === "") {
    setConfigureError((prevState: any) => ({
      ...prevState,
      phoneNumber: "Please enter phone number",
    }));
    isError = true;
  } else if (!isContactValid) {
    setConfigureError((prevState: any) => ({
      ...prevState,
      phoneNumber: "Please enter valid phone number",
    }));
    isError = true;
  }
  if (data.price === "") {
    setConfigureError((prevState: any) => ({
      ...prevState,
      price: "Please enter price",
    }));
    isError = true;
  } else if (isNaN(Number(data.price))) {
    setConfigureError((prevState: any) => ({
      ...prevState,
      price: "Please enter price in number",
    }));
    isError = true;
  }

  if (data.percentage === "") {
    setConfigureError((prevState: any) => ({
      ...prevState,
      percentage: "Please enter percentage",
    }));
    isError = true;
  } else if (isNaN(Number(data.percentage))) {
    setConfigureError((prevState: any) => ({
      ...prevState,
      percentage: "Please enter percentage in number",
    }));
    isError = true;
  }

  if (data.renewalGracePeriod === "") {
    setConfigureError((prevState: any) => ({
      ...prevState,
      renewalGracePeriod: "Please Select Renewal Period",
    }));
    isError = true;
  } else if (isNaN(Number(data.renewalGracePeriod))) {
    setConfigureError((prevState: any) => ({
      ...prevState,
      renewalGracePeriod: "Please Select valid Renewal Period",
    }));
    isError = true;
  }
  return isError;
};
